export const selectSearchString = (searchState: any) => {
  return searchState?.search?.searchStr;
}

export const selectFilterBy = (searchState: any) => {
  return searchState?.search?.filterBy;
}
